import React, { useContext, useEffect } from "react";
import { AUDIO_TYPE } from "./../../ricos-content/index.js";
import { PluginsEventsContext } from "./../../ricos-context/index.js";
import { HTMLData_Source } from "./../../ricos-schema/next-schema/index.js";
import { HtmlViewer as HtmlComponent } from "../../plugin-html/viewer/html-viewer.js";
import { AUDIO_TYPES } from "../consts.js";
const AudioEmbedViewer = ({ node, settings }) => {
  const pluginsEvents = useContext(PluginsEventsContext) || {};
  const nodeId = node.id;
  const html = node.audioData?.html;
  const url = node.audioData?.audio?.src?.url ?? "";
  const htmlCompProps = {
    htmlData: {
      html,
      source: HTMLData_Source.HTML,
      containerData: {
        width: {
          custom: "100%"
        },
        height: {
          custom: "100%"
        },
        url
      }
    },
    settings
  };
  useEffect(() => {
    nodeId && pluginsEvents?.publishMediaPluginsDetails?.({
      pluginId: AUDIO_TYPE,
      nodeId,
      creator: void 0,
      title: void 0,
      track_duration: void 0,
      type: AUDIO_TYPES.spotify,
      url
    });
  }, []);
  return /* @__PURE__ */ React.createElement(HtmlComponent, { ...htmlCompProps });
};
var audio_embed_viewer_default = AudioEmbedViewer;
export {
  audio_embed_viewer_default as default
};
//# sourceMappingURL=audio-embed-viewer.js.map
